module.exports = __webpack_public_path__ + "img/banner.cd1ceab4.jpg";